// Google Maps JS API is injected asynchronously from public/index.html
// (script.async = true). Components that use `google.maps.*` can therefore
// mount before the script finishes loading, which throws
// "ReferenceError: google is not defined" and crashes the React tree.
// whenGoogleMapsReady waits until the Places library is available before
// running the callback, and returns a cleanup function to cancel the wait.

export const isGoogleMapsReady = () =>
  typeof window !== 'undefined' &&
  window.google &&
  window.google.maps &&
  window.google.maps.places

export const whenGoogleMapsReady = (callback, { interval = 200, timeout = 15000 } = {}) => {
  if (isGoogleMapsReady()) {
    callback()
    return () => {}
  }

  let cancelled = false
  let elapsed = 0

  const timer = setInterval(() => {
    if (cancelled) return
    if (isGoogleMapsReady()) {
      clearInterval(timer)
      callback()
    } else if ((elapsed += interval) >= timeout) {
      clearInterval(timer)
    }
  }, interval)

  return () => {
    cancelled = true
    clearInterval(timer)
  }
}
